import apiClient from '../apiClient';

let ControllerName = 'Specialization';
const specializationControllers = Object.freeze({
    specializationsDropdown: `${ControllerName}/specializations-dropdown`,
    subSpecializations: `${ControllerName}/sub-specializations-dropdown`,
});

/**
* get specialization dropdown
*/
export const getSpecializationDropdown = async () => {
    try{
        const response = await apiClient.get(`${specializationControllers.specializationsDropdown}`);
        //console.log(response)
        return response.data
    }catch(error){
        throw new Error(error.message || "Failed to fetch specialize");
    }
}


/**
* get Sub specialization dropdown
*/
export const getSubSpecialization = async (id) => {
    try{
        const response = await apiClient.get(`${specializationControllers.subSpecializations}`,{
            params: { Id: id }
        });
        console.log("SubSpecializations:", response.data);
        return response.data
    }catch(error){
        console.error("Error fetching sub-specializations:", error); 
        throw new Error(error.message || "Failed to fetch specialize");
    }
}